import React from 'react';
import Pages from './basic_page';
class Material extends Pages {
    render() {
        return (
    <>
        <h1 className='des_met'>
            Methods
        </h1>
        <div className='pageholder'>
            <div className='leftmenu'>
                <div>Methods</div>
                <button onClick={() => this.scroll(this.firstRef)}>Protocol</button>
                <button onClick={() => this.scroll(this.secondRef)}>Materials</button>
			</div>
            
            <div className='righttext'>
                <div className='P1' ref={this.firstRef}>
                <div className='text_wrap'>
                        <h3>Protocol</h3>
                        <a href='https://static.igem.wiki/teams/4298/wiki/protocol.pdf' >click to download Protocol.pdf</a>
				</div>
                
                </div>
				<div className='P2' ref={this.secondRef}>
				<div className='text_wrap'>
                    <h3>Material</h3>
                    <h4>Plasmids</h4>
                    <p>pLeu2 :Was used as backbone for α-secretory system. pLeu2 was a gift from Sihong Li.</p>
                    <p>pLXR6 :Was used as backbone for EPI. pLXR6 was a gift from Sihong Li.</p>
                    <p>pUC19-ITR :Was used as backbone for α-secretory system and orthoRep system. pUC19-ITR was a gift from Bluepha.</p>
                    <p>pyEVR :Was used for EvolvR system. pyEVR was a gift from Bluepha.</p>
                    <p>pAR-ec633 :A plasmid for OrthoRep system, containingΔDNAP gene which guides error-prone replication. pAR-ec633 was a gift from Bluepha.</p>
                    <p>pTac-RJN-AcrB-mCh :Was used to cause bacteria to overexpress AcrB and thus acquire resistance. With a mCherry gene expressed in tandem with the AcrB gene, we can determine whether the plasmid was successfully transferred from the color.</p>
                    <p>pUC57-TEF-α secretion signal-GFP :Using pUC57 as the backbone, and contained α-secretory factor element. Was used to build the secretory system.</p>
                    <p>pLeu2-α-GFP :Using pLeu2 as the backbone, and contained α-secretory factor element through Gibson assembly. Was used to build the secretory system.</p>
                    <p>pITR-EPI :Using pLeu2 as the backbone, and contained EPI gene.</p>
                    <p>pEVR-EPI :Using pyEVR as the backbone, and was simultaneously transferred with pITR-EPI to construct the EvolvR system.</p>
                    <div className="img_wrap">
                        <img src="https://static.igem.wiki/teams/4298/wiki/meth-table1.png"/>
                    </div>
                    <h3>Strains</h3>
                    <h6>E.Coli</h6>
                    <p>DH5-alpha ：Used for transformation and co-culture.</p>
                    <p>DH-10-β ：Used for transformation</p>
                    <p>Top-10 ：Used for transformation</p>
                    <h6>S.Cerevisiae</h6>
                    <p>Used for co-culture and directed evolution of EPI.</p>
                    <h3>Primers</h3>
                    <div className="img_wrap">
                        <img src="https://static.igem.wiki/teams/4298/wiki/meth-table2.png"/>
                        <br></br>
                        <br></br>
                        <img src="https://static.igem.wiki/teams/4298/wiki/meth-table3.png"/>
                    </div>


                </div>

				</div>
            </div>
		</div>
    </>

  );
    }
};

export default Material;























